export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  imageQuery: string;
  tags: string[];
}

export const categories: Category[] = [
  {
    slug: "sexual-health",
    name: "性健康基础",
    description: "了解身体构造、生理反应与健康管理，建立科学的性知识体系",
    icon: "ri-heart-pulse-line",
  },
  {
    slug: "intimacy-relationship",
    name: "亲密关系经营",
    description: "探索如何增进伴侣间的情感联结，建立更深层的亲密关系",
    icon: "ri-hand-heart-line",
  },
  {
    slug: "techniques-methods",
    name: "性技巧与方法",
    description: "从科学角度解析做爱技巧，提升双方的性体验与满意度",
    icon: "ri-lightbulb-flash-line",
  },
  {
    slug: "psychology-emotion",
    name: "心理与情感",
    description: "理解性心理、消除焦虑与障碍，建立健康的性观念",
    icon: "ri-mental-health-line",
  },
  {
    slug: "couple-communication",
    name: "两性沟通",
    description: "学习如何与伴侣有效沟通性需求与边界，创造安全的对话空间",
    icon: "ri-chat-heart-line",
  },
];

export const articles: Article[] = [
  {
    slug: "understanding-sexual-response-cycle",
    title: "性反应周期的四个阶段：从欲望到高潮的生理旅程",
    excerpt: "了解人类性反应周期的完整过程\u2014\u2014兴奋期、平台期、高潮期和消退期，帮助你和伴侣更好地理解彼此的身体信号，提升亲密体验的质量。",
    content: `<p>性反应周期是理解人类性行为的基础理论之一。由Masters和Johnson在20世纪60年代提出的四阶段模型，至今仍然是性科学领域的重要参考框架。了解这一周期不仅有助于自我认知，更能帮助伴侣之间建立更深的默契。</p>
<h2>第一阶段：兴奋期</h2>
<p>兴奋期是性反应的起始阶段，可以由身体接触、视觉刺激、幻想或情感联结等多种因素触发。在这个阶段，身体开始产生一系列生理变化：心率加快、血压升高、肌肉张力增加。对于女性而言，阴道开始分泌润滑液，阴蒂和小阴唇充血肿胀；对于男性，阴茎开始勃起，阴囊皮肤收紧。</p>
<p>这一阶段的关键在于放松和专注。许多人在这个阶段会因为焦虑或分心而无法充分进入状态。建议伴侣创造一个安静、私密的环境，通过前戏和情感交流帮助彼此充分放松。</p>
<h2>第二阶段：平台期</h2>
<p>平台期是兴奋期的延续和强化。在这个阶段，所有的生理变化达到一个较高的稳定水平。呼吸变得急促，心率进一步加快，肌肉张力持续增加。女性在这个阶段会出现高潮平台现象，阴道外三分之一处充血肿胀，形成紧握感；男性则可能出现尿道球腺分泌的少量液体。</p>
<p>平台期的持续时间因人而异，从几分钟到数十分钟不等。这个阶段的充分发展对于之后的高潮质量至关重要。伴侣之间的节奏配合和相互反馈能够帮助延长和深化这一阶段。</p>
<h2>第三阶段：高潮期</h2>
<p>高潮是性反应周期中性快感达到顶峰的阶段，通常持续数秒到十几秒。在这个阶段，盆底肌肉群会发生一系列有节律的收缩，伴随强烈的愉悦感和释放感。高潮的体验因人而异，也因情境而异，没有所谓的标准答案。</p>
<p>值得注意的是，并非每次性行为都需要以高潮为终点。将高潮视为唯一目标反而可能增加心理压力，影响双方的体验。享受整个过程本身，比追求特定结果更为重要。</p>
<h2>第四阶段：消退期</h2>
<p>高潮之后，身体逐渐恢复到兴奋前的状态。这个阶段的特点是放松和满足感，但也可能伴随情绪波动。男性的消退期通常较快，且存在不应期，在一段时间内无法再次达到高潮；而女性则没有明显的不应期，在理论上可以连续多次达到高潮。</p>
<p>消退期是建立情感联结的黄金时刻。依偎、轻抚和交流能够巩固亲密感，让伴侣在身体和情感上都能感受到充分的关爱与满足。</p>`,
    category: "sexual-health",
    author: "性健康研究团队",
    date: "2026-07-15",
    readTime: "8 分钟",
    imageSeq: "article-sexual-response",
    imageQuery: "Soft%20warm%20abstract%20art%20representing%20intimate%20connection%20between%20two%20people%2C%20flowing%20organic%20shapes%20in%20warm%20terracotta%20and%20cream%20tones%2C%20gentle%20gradients%2C%20artistic%20minimal%20composition%2C%20scientific%20yet%20sensual%20aesthetic%2C%20clean%20background",
    tags: ["性反应周期", "生理知识", "高潮", "性科学"],
  },
  {
    slug: "building-emotional-intimacy",
    title: "深度亲密关系的五个层次：从身体接触到灵魂共鸣",
    excerpt: "真正的亲密不仅仅是身体的结合。本文从心理学角度分析亲密关系的五个层次，帮助伴侣逐步建立从身体到心灵的完整联结，让每一次亲密都更有意义。",
    content: `<p>亲密关系是一个多维度的概念，远远超越了身体的接触。心理学家将亲密关系划分为多个层次，每一层都需要伴侣共同努力去构建和维护。当你和伴侣能够在这五个层次上都建立联结，你们的关系将变得更加深厚和满足。</p>
<h2>第一层：身体亲密</h2>
<p>身体亲密是最基础的层次，包括牵手、拥抱、亲吻以及性行为。身体的接触能够释放催产素，常被称为爱的荷尔蒙，它有助于建立信任感和依恋感。然而，如果身体亲密脱离了其他层次的配合，它可能变得机械而空洞。</p>
<h2>第二层：情感亲密</h2>
<p>情感亲密是指双方能够安全地分享内心感受的能力。这包括表达喜悦、悲伤、恐惧和脆弱，而不必担心被评判或拒绝。当伴侣能够坦诚地交流情感时，身体接触会变得更加富有意义。建立一个无论说什么都能被接纳的安全空间，是发展情感亲密的关键。</p>
<h2>第三层：智力亲密</h2>
<p>智力亲密体现在双方能够在思想层面进行深度的交流和碰撞。分享观点、讨论感兴趣的话题、一起学习新事物，这些都是智力亲密的表现。当伴侣能够在精神层面互相激发、彼此欣赏时，关系会获得持久的活力。</p>
<h2>第四层：价值亲密</h2>
<p>当伴侣在核心人生价值观上达到一致或相互理解时，就进入了价值亲密的层次。这包括对家庭、事业、金钱、信仰等重要议题的看法。价值层面的契合并不意味着在所有事情上都完全一致，而是能够在差异中保持尊重和包容。</p>
<h2>第五层：灵性亲密</h2>
<p>灵性亲密是最高层次的联结，它超越了具体的语言和行为。这是一种共享的存在感，你们一起经历生活的高低起伏，在彼此的陪伴中感受到生命的完整与意义。达到这个层次的伴侣常常描述自己与对方之间存在一种难以言说的默契和归属感。</p>
<p>这五个层次并非严格线性发展，而是相互交织、共同成长的。你可以在某次深谈中同时触及情感、智力和价值的多个层次。重要的是保持开放的心态，持续在每一个层次上投入关注和努力。</p>`,
    category: "intimacy-relationship",
    author: "情感关系研究所",
    date: "2026-07-20",
    readTime: "10 分钟",
    imageSeq: "article-emotional-intimacy",
    imageQuery: "Warm%20abstract%20artwork%20showing%20two%20flowing%20forms%20gently%20intertwining%2C%20soft%20terracotta%20and%20cream%20colors%2C%20minimalist%20composition%2C%20emotional%20connection%20theme%2C%20gentle%20gradients%2C%20clean%20background%2C%20artistic%20render",
    tags: ["亲密关系", "情感联结", "伴侣关系", "心理学"],
  },
  {
    slug: "importance-of-foreplay",
    title: "前戏的科学：为什么它比你想的更重要",
    excerpt: "前戏不仅仅是性爱前的预热环节，它是建立性兴奋、情感联结和身体准备的关键过程。了解前戏的生理与心理机制，让你的亲密体验更完整、更满足。",
    content: `<p>在许多人的认知中，前戏只是性行为正式开始的前奏。然而从科学的角度来看，前戏本身就是完整的性体验中不可或缺的一部分，它的意义远超预热这么简单。</p>
<h2>前戏的生理学意义</h2>
<p>从生理角度来看，前戏的核心作用是激活身体的性反应系统。充分的触觉刺激能够促进血液循环，使生殖器官充血膨胀，为后续的性行为做好准备。对于女性而言，充分的前戏是阴道润滑的关键条件，润滑不足不仅会影响快感，还可能造成不适甚至疼痛。研究表明，女性平均需要20分钟以上的有效刺激才能达到充分的生理准备状态。</p>
<p>此外，前戏过程中释放的神经递质和激素，包括多巴胺、催产素和内啡肽，不仅增强当下的愉悦感，还有助于建立长期的亲密联结。</p>
<h2>前戏的心理学意义</h2>
<p>前戏不仅仅是身体的准备，更是心理的切换过程。从日常生活模式切换到亲密模式的转变需要时间。通过前戏，伴侣可以将注意力从外界转移回彼此身上，建立起安全、专注的亲密空间。这个心理转换过程对于很多人来说，是能否充分投入性体验的决定性因素。</p>
<h2>前戏不等于前戏</h2>
<p>一个常见的误区是将前戏严格限定在卧室中的、以性器官为中心的活动。实际上，前戏可以也应该渗透在日常生活中。一条温馨的短信、一个突如其来的拥抱、一起做饭时的肢体接触，这些都是前戏的延伸。将亲密感融入日常，会让卧室中的体验更加自然和深刻。</p>
<h2>如何丰富前戏体验</h2>
<p>多样性是保持前戏新鲜感的关键。除了常规的身体接触外，可以尝试全身按摩、共浴、一起阅读相关文学作品、使用情趣用品等不同的方式。重要的是保持探索和沟通的开放态度，了解彼此的偏好和边界。</p>
<p>最后要记住：前戏不是达到目的的手段，它就是亲密体验本身的重要组成部分。当你开始这样看待前戏时，整个体验都会变得更加丰富和满足。</p>`,
    category: "techniques-methods",
    author: "性健康研究团队",
    date: "2026-07-25",
    readTime: "7 分钟",
    imageSeq: "article-foreplay",
    imageQuery: "Abstract%20warm%20art%20featuring%20soft%20tactile%20textures%2C%20gentle%20caress%20theme%2C%20flowing%20curves%20in%20terracotta%20and%20cream%2C%20intimate%20atmosphere%2C%20minimalist%20composition%2C%20clean%20elegant%20aesthetic%2C%20subtle%20gradients",
    tags: ["前戏", "性技巧", "性体验", "伴侣沟通"],
  },
  {
    slug: "overcoming-sexual-anxiety",
    title: "走出性焦虑：从自我接纳到自在表达",
    excerpt: "性焦虑是许多成年人面临的隐形困扰。本文从心理学角度剖析性焦虑的根源，提供科学的应对策略，帮助你在亲密关系中找到自信与放松。",
    content: `<p>性焦虑是普遍存在却鲜少被公开讨论的话题。它可能表现为对自身身体的不自信、对性表现的担忧、对伴侣评价的恐惧，或是对性行为本身的不安。这些焦虑如果长期得不到处理，不仅会影响性生活的质量，还可能损害亲密关系的整体健康。</p>
<h2>性焦虑的常见根源</h2>
<p>性焦虑的来源是多方面的。社会文化中不切实际的性标准，无论是来自色情制品的夸张表现，还是社交媒体上精心修饰的身体形象，都会让人产生我不够好的自我怀疑。过往的负面性经历、成长过程中接受的性教育不足、以及与伴侣之间缺乏开放的沟通，都可能成为焦虑的温床。</p>
<p>此外，表现焦虑是男性中尤其常见的问题。对勃起硬度、持续时间以及能否让伴侣满意的过度关注，反而会造成心理压力，形成越担心越不行的恶性循环。</p>
<h2>打破焦虑的第一步：自我接纳</h2>
<p>克服性焦虑的起点是接纳自己，接纳自己的身体、接纳自己的欲望、接纳自己可能会不完美。每个人都有独特的身体和性反应模式，正常是一个光谱而非一个点。当你停止用他人的标准来评判自己时，焦虑的根基就已经开始松动了。</p>
<h2>实用的应对策略</h2>
<p>正念练习是处理性焦虑的有效工具。通过专注于当下的身体感受，触觉、温度、呼吸，而非沉浸在评价性的思绪中，你可以逐渐从思考模式切换到感受模式。研究表明，定期的正念练习能够显著降低性焦虑水平。</p>
<p>与伴侣的开放沟通同样至关重要。坦诚地表达你的担忧和需求，不仅能够获得对方的理解与支持，还能消除因猜测而产生的额外焦虑。当你发现伴侣并不会因为你的不完美而评判你时，焦虑自然会减轻。</p>
<p>如果性焦虑严重影响了你的生活质量，寻求专业的性治疗师或心理咨询师的帮助是完全合理且值得鼓励的选择。性健康是整体健康不可分割的一部分，它值得被认真对待。</p>`,
    category: "psychology-emotion",
    author: "心理健康研究中心",
    date: "2026-07-28",
    readTime: "9 分钟",
    imageSeq: "article-anxiety",
    imageQuery: "Warm%20abstract%20composition%20symbolizing%20inner%20peace%20and%20self-acceptance%2C%20soft%20flowing%20shapes%20in%20terracotta%20and%20cream%2C%20calming%20atmosphere%2C%20minimalist%20design%2C%20gentle%20gradients%2C%20clean%20background",
    tags: ["性焦虑", "自我接纳", "心理健康", "正念"],
  },
  {
    slug: "effective-sexual-communication",
    title: "怎么说出口？伴侣间性需求沟通的实用指南",
    excerpt: "与伴侣谈论性需求和边界常常令人紧张。本文提供具体、可操作的沟通框架和话术，帮助你和伴侣建立开放、尊重的性对话习惯。",
    content: `<p>在亲密关系中，能够坦然地讨论性需求与边界，是关系健康的重要标志之一。然而对于许多伴侣来说，聊性仍然是一件难以启齿的事情。文化背景、成长经历、个性差异等因素都可能让这个话题变得敏感而复杂。</p>
<h2>为什么性沟通如此困难？</h2>
<p>首先需要认识到，性沟通的困难是普遍的，并非你们关系的特有问题。从小我们接受的教育中，性往往是一个被回避或羞耻化的话题。这种长期的文化影响不会因为我们进入一段亲密关系就自动消失。此外，谈论性意味着暴露自己的脆弱面，你的欲望、你的不安全感、你的身体，这种暴露本身就具有风险感。</p>
<h2>创设安全的对话空间</h2>
<p>性沟通需要在安全的氛围中进行。避免在性行为进行中或刚刚结束后立即提出敏感的反馈，因为此时双方的情绪状态都较为脆弱。选择一个双方都放松、不赶时间的时刻，在私密的环境中展开对话。可以提前说明我想和你聊一聊我们之间的一些感受，这不是批评，只是我想更好地了解你，也让你更好地了解我。这样的铺垫可以有效降低对方的防御心理。</p>
<h2>我语句的魔力</h2>
<p>在表达需求和不满意时，使用我语句而非你语句可以大大减少对方的抵触情绪。比较这两种表达方式：</p>
<p>不推荐：你从来都不关心我的感受。（指责性，容易引发防御）</p>
<p>推荐：我希望我们能有更多的时间来相互了解彼此的身体感受。（表达自身愿望，邀请合作）</p>
<p>我语句的核心是表达自己的感受和需求，而非评价对方的行为。这样的表达方式让对方感受到的不是攻击，而是信任，你愿意与他分享内心真实的声音。</p>
<h2>倾听比表达更难</h2>
<p>有效的性沟通中，倾听的重要性不亚于表达。当伴侣向你袒露他或她的性需求或不满时，克制住立即辩解或反击的冲动，先尝试理解对方的感受。你可以说：谢谢你告诉我这些，我需要一点时间来消化，但我很感激你的坦诚。这样的回应让对方感到被接纳，为后续的深入交流奠定了基础。</p>
<h2>定期关系体检</h2>
<p>将性沟通从出问题时才谈转变为定期的话题。可以设定每月一次的关系体检时间，双方轮流分享这段时间在亲密关系中的感受、需求和期待。当性沟通成为习惯而非应急措施时，它的压力感和敏感度都会大大降低。</p>`,
    category: "couple-communication",
    author: "情感关系研究所",
    date: "2026-08-01",
    readTime: "8 分钟",
    imageSeq: "article-communication",
    imageQuery: "Abstract%20warm%20art%20symbolizing%20open%20dialogue%20and%20connection%2C%20two%20intertwined%20flowing%20forms%20in%20terracotta%20and%20cream%2C%20harmonious%20composition%2C%20minimalist%20aesthetic%2C%20gentle%20warm%20light%2C%20clean%20background",
    tags: ["性沟通", "伴侣关系", "表达需求", "倾听"],
  },
  {
    slug: "sexual-health-maintenance",
    title: "性健康维护指南：从日常习惯到定期检查",
    excerpt: "性健康是整体健康的重要组成部分。本文系统梳理了男性和女性在日常生活中有助于维护性健康的习惯、饮食建议以及需要关注的健康指标。",
    content: `<p>性健康常常被孤立地看待，实际上它与心血管健康、内分泌系统、心理健康以及整体生活方式密切相关。维护良好的性健康，本质上就是维护良好的整体健康。</p>
<h2>生活方式与性健康</h2>
<p>规律的有氧运动是改善性功能的最有效方法之一。运动能够促进血液循环，包括骨盆区域的血液流动，这对男性的勃起功能和女性的性敏感度都有直接的积极影响。每周至少150分钟的中等强度有氧运动（如快走、游泳、骑行）能够显著改善性健康指标。</p>
<p>睡眠质量同样至关重要。长期的睡眠不足会影响睾酮等性激素的分泌水平，进而影响性欲和性功能。保持每晚7到8小时的高质量睡眠，是维护性健康的基础。</p>
<h2>营养与性功能</h2>
<p>均衡的饮食对性健康有直接的促进作用。富含抗氧化物的食物（如深色蔬菜、浆果、坚果）有助于保护血管健康，而良好的血液循环是一切性功能的基础。富含锌的食物（如牡蛎、瘦红肉、南瓜籽）对性激素的合成至关重要。Omega-3脂肪酸（来自深海鱼类、亚麻籽）则有助于减少炎症、改善血液循环。</p>
<h2>心理健康与性</h2>
<p>长期的压力、焦虑和抑郁都会对性健康造成显著的负面影响。压力激素皮质醇的持续升高会抑制性激素的分泌。因此，压力管理——无论是通过运动、冥想、兴趣爱好还是专业心理咨询——都是性健康维护不可忽视的一环。</p>
<h2>定期健康检查</h2>
<p>性健康还需要主动的医疗管理。对于女性，定期的妇科检查（包括宫颈癌筛查）是必不可少的。对于男性，前列腺健康检查应随着年龄的增长纳入常规体检。此外，如果你有多个性伴侣，定期的性传播感染（STI）筛查是对自己和伴侣负责任的行为。</p>
<p>性健康不是禁忌话题，而是每个人都应该认真对待的健康维度。主动了解、积极维护、及时就医，才能确保性健康与整体健康同步发展。</p>`,
    category: "sexual-health",
    author: "性健康研究团队",
    date: "2026-08-05",
    readTime: "6 分钟",
    imageSeq: "article-health-maintenance",
    imageQuery: "Abstract%20warm%20composition%20representing%20wellness%20and%20vitality%2C%20organic%20flowing%20shapes%20in%20terracotta%20and%20cream%2C%20health%20and%20wellness%20theme%2C%20minimalist%20aesthetic%2C%20soft%20warm%20lighting%2C%20clean%20background",
    tags: ["性健康", "生活方式", "营养", "健康检查"],
  },
];